export const SESSION_RESCHEDULE_START = "Session_Reschedule_Start";
export const SESSION_RESCHEDULE_END = "Session_Reschedule_End";
export const SESSION_CANCEL_START = "Session_Cancel_Start";
export const SESSION_CANCEL_END = "Session_Cancel_End";
